"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EOSEndpoint = void 0;
const EOSEndpoint = exports.EOSEndpoint = {
  generic: "GENERIC",
  serviceManagement: "SERVICE_MANAGEMENT",
  vehicleHealth: "VEHICLE_HEALTH",
  vehicleInfo: "VEHICLE_INFO",
  vehicleMaintenance: "VEHICLE_MAINTENANCE",
  vehicleManagement: "VEHICLE_MANAGEMENT",
  vehicleSubscription: "VEHICLE_SUBSCRIPTION"
};